var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoCheckPsd = function SvgNoCheckPsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888B94",
    d: "M17.813 13.67a.626.626 0 0 1-.854-.234l-1.484-2.593a9.6 9.6 0 0 1-2.819 1.301l.459 2.752a.626.626 0 0 1-.615.728.625.625 0 0 1-.616-.523l-.45-2.701c-.951.132-1.915.132-2.866 0l-.45 2.701a.625.625 0 1 1-1.235-.205l.46-2.752a9.6 9.6 0 0 1-2.816-1.304l-1.48 2.596a.627.627 0 1 1-1.09-.625l1.563-2.734a12 12 0 0 1-1.508-1.563.625.625 0 1 1 .974-.78C4.283 9.337 6.552 11.248 10 11.248s5.717-1.913 7.014-3.516a.627.627 0 0 1 1.067.066.625.625 0 0 1-.095.715 12 12 0 0 1-1.508 1.563l1.563 2.734a.625.625 0 0 1-.229.86"
  })));
};
export default SvgNoCheckPsd;